// Sentry initialization should be imported first: https://docs.sentry.io/platforms/javascript/guides/react/#configure
import "@src/sentry-init";

import { ErrorBoundary } from "@context-providers/error-boundary/error-boundary";
import { LoadingSpinnerProvider } from "@context-providers/loading-spinner-provider";
import { NetworkConnectionProvider } from "@context-providers/network-connection/network-connection-provider";
import { FileUploadContextProvider } from "@context-providers/file-upload/file-uploads-context";
import { ToastProvider } from "@context-providers/toast/toast-provider";
import { TokensServiceProvider } from "@context-providers/tokens-service-provider";
import { CookieManagerLoader } from "@hooks/cookie-manager-loader";
import { IntercomLoader } from "@loaders/intercom-loader";
import { LocalizeLoader } from "@loaders/localize-loader";
import { router } from "@router/router";
import "@src/index.css";
import { store } from "@store/store";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";
import { DynamicThemeProvider } from "@components/common/dynamic-theme-provider";

// CssBaseline needs to be imported before all other styles to avoid errors
import { CssBaseline} from "@mui/material";

createRoot(document.getElementById("root") as HTMLElement).render(
  <StrictMode>
    <Provider store={store}>
      <CookieManagerLoader>
        <LocalizeLoader>
          <CssBaseline />
          <DynamicThemeProvider>
            <ToastProvider>
              <NetworkConnectionProvider>
                <ErrorBoundary>
                  <LoadingSpinnerProvider>
                    <TokensServiceProvider>
                      <FileUploadContextProvider>
                        <IntercomLoader>
                          <RouterProvider
                            router={router}
                            future={{
                              // eslint-disable-next-line @typescript-eslint/naming-convention
                              v7_startTransition: true,
                            }}
                          />
                        </IntercomLoader>
                      </FileUploadContextProvider>
                    </TokensServiceProvider>
                  </LoadingSpinnerProvider>
                </ErrorBoundary>
              </NetworkConnectionProvider>
            </ToastProvider>
          </DynamicThemeProvider>
        </LocalizeLoader>
      </CookieManagerLoader>
    </Provider>
  </StrictMode>
);
